<template>
  <b-sidebar
    id="sidebar-group-update"
    sidebar-class="sidebar-customer"
    :visible="shallShowModal"
    bg-variant="white"
    shadow
    no-close-on-backdrop
    no-header
    right
    @change="(val) => $emit('update:shall-show-modal', val)"
  > 
   <template #default="{ hide }">
    <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
      <h5 class="mb-0"> {{ formData.id ? '编辑': '添加' }}数据组 </h5>
      <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
    </div>

    <validation-observer ref="refFormObserver">
      <b-form class="p-2">
        <!-- name -->
        <b-row>
          <b-col cols="12" md="6">
            <validation-provider #default="{ errors }" name="数据组名称" rules="required">
              <b-form-group label="数据组名称" label-for="group-name" label-cols="auto">
                <b-form-input id="group-name" v-model="formData.name" trim
                  :state="errors.length > 0 ? false:null" placeholder="数据组名称"
                />
                <b-form-invalid-feedback> {{ errors[0] }} </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" md="6">
          <!-- configName -->
            <validation-provider #default="{ errors }" name="数据组标识" rules="required">
              <b-form-group label="数据组标识" label-for="group-engName" label-cols="auto">
                <b-form-input
                  id="group-engName"
                  v-model="formData.configName" trim
                  :state="errors.length > 0 ? false:null"
                  placeholder="数据组标识"
                />
                <b-form-invalid-feedback> {{ errors[0] }} </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <!-- info -->
        <b-form-group label="数据组描述" label-for="group-info" label-cols="auto">
          <!-- <b-form-textarea id="group-info" placeholder="数据组描述" v-model="formData.info" trim rows="1" /> -->
          <b-form-input id="group-info" placeholder="数据组描述" v-model="formData.info" trim />
        </b-form-group>

        <b-card-body class="zero-padding-card">
          <div ref="form" class="repeater-form-group" :style="{height: trHeight}">
            <div
              v-for="(item, index) in formData.fieldsObjArray"
              :key="index" ref="row"
              class="pb-1 form-item-section-group"
              :class="index === 0 ? 'pt-1': ''"
            >
              <!-- Item Form -->
              <!-- ? This will be in loop => So consider below markup for single item -->
              <b-col cols="12">
                <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                <div class="d-flex border rounded">
                  <b-row class="flex-grow-1 px-1 pt-1">
                    <!-- name -->
                    <b-col cols="12" md="4">
                      <validation-provider mode="passive" #default="{ errors }" :name="`字段名称${index + 1}`" rules="required">
                        <b-form-group label="字段名称" :label-for="`fields-name-${index}`" label-cols="auto">
                          <b-form-input :id="`fields-name-${index}`" v-model="item.name" trim
                            :state="errors.length > 0 ? false:null" placeholder="字段名称"
                          />
                          <b-form-invalid-feedback> {{ errors[0] }} </b-form-invalid-feedback>
                        </b-form-group>
                        <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                      </validation-provider>
                    </b-col>
                    <b-col cols="12" md="4">
                    <!-- title -->
                      <validation-provider mode="passive" #default="{ errors }" :name="`字段标识${index + 1}`" rules="required">
                        <b-form-group label="字段标识" :label-for="`fields-title-${index}`" label-cols="auto">
                          <b-form-input
                            :id="`fields-title-${index}`"
                            v-model="item.title" trim
                            :state="errors.length > 0 ? false:null"
                            placeholder="字段标识"
                          />
                          <b-form-invalid-feedback> {{ errors[0] }} </b-form-invalid-feedback>
                        </b-form-group>
                        <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                      </validation-provider>
                    </b-col>
                    <!-- type -->
                    <b-col cols="12" md="4">
                      <validation-provider mode="passive" #default="{ errors }" :name="`字段类型${index + 1}`" rules="required">
                        <b-form-group label="字段类型" :label-for="`fields-type-${index}`" label-cols="auto">
                          <!-- <b-form-input id="fields-type" v-model="item.type" trim
                            :state="errors.length > 0 ? false:null" placeholder="字段类型"
                          /> -->
                          <!-- @input="val => updateItemForm(index, val)" -->
                          <v-select
                            v-model="item.type"
                            :id="`fields-type-${index}`"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :state="errors.length > 0 ? false:null"
                            :options="itemsOptions"
                            label="text" placeholder="字段类型" :clearable="false"
                            class="item-selector-title"
                            :reduce="val => val.value"
                            @input="val => resetItem(val,index)"
                          >
                            <template v-slot:no-options>没有找到相关信息</template>
                          </v-select>
                        </b-form-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-col>
                    <b-col cols="12">
                    <!-- param  -->
                      <validation-provider
                        mode="passive"
                        v-if="['radio','select','checkbox'].includes(item.type)"
                        #default="{ errors }"
                        :name="`字段参数${index + 1}`"
                        rules="required"
                      >
                        <b-form-group
                          label="字段参数"
                          :label-for="`fields-param-${index}`"
                          label-cols="auto"
                        >
                          <!-- :value="JSON.stringify(item.param)" -->
                          <b-form-textarea
                            :id="`fields-param-${index}`"
                            v-model="item.param"
                            :state="errors.length > 0 ? false:null"
                            placeholder="字段参数"
                            rows="2"
                            disabled
                          />
                          <b-form-invalid-feedback> {{ errors[0] }} </b-form-invalid-feedback>
                        </b-form-group>
                        <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                      </validation-provider>
                    </b-col>
                  </b-row>
                  <div class="d-flex flex-column justify-content-between border-left py-50 px-25">
                    <feather-icon
                      size="16"
                      icon="XIcon"
                      class="cursor-pointer"
                      @click="removeItem(index)"
                    />
                    <feather-icon
                      v-show="['radio','select','checkbox'].includes(item.type)"
                      :id="`form-item-settings-icon-${index + 1}`"
                      size="16"
                      icon="SettingsIcon"
                      class="cursor-pointer"
                    />
                    <ParamPopover :index="index + 1" :param="item.param" @up-param="getParam"></ParamPopover>
                  </div>
                </div>
              </b-col>
            </div>
          </div>
          <div class="d-flex justify-content-end mt-1 mr-1">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" @click="addNewItemInItemForm">
              添加字段
            </b-button>
          </div>
        </b-card-body>
      </b-form>
    </validation-observer>
    </template>
    <template #footer>
      <div class="p-2 border-top cursor-pointer d-flex justify-content-between">
        <div>
          <b-button variant="outline-primary" class="cursor-pointer mr-1" @click="reset">
            重置
          </b-button>
          <b-button variant="outline-secondary" class="cursor-pointer ml-0" @click="$emit('update:shall-show-modal', false)">
            取消
          </b-button>
        </div>
        <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="primary" class="mb-1 mb-sm-0" @click="updateForm">
          确定
        </b-button>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import vSelect from 'vue-select'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import ParamPopover from './ParamPopover.vue'

export default {
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  components: {
    vSelect,
    ValidationProvider,
    ValidationObserver,
    ParamPopover,
  },
  model: {
    prop: 'shallShowModal',
    event: 'update:shall-show-modal',
  },
  props: {
    shallShowModal: {
      type: Boolean,
      required: true,
    },
    info: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    /* 必要组件加载区域 */

    /* 组件页面数据准备区域，包括表单，下拉选择项，数据整理操作等 */
    // 状态参数
    const itemsOptions = [
      { text: '文本', value: 'input' },
      { text: '多行', value: 'textarea' },
      { text: '单选', value: 'radio' },
      { text: '多选', value: 'checkbox' },
      { text: '下拉', value: 'select' },
      // { text: '单图', value: 'upload' },
      // { text: '多图', value: 'uploads' },
      { text: '数字', value: 'number' },
    ]
    // 自定义字段组件添加等操作,由于导入的mixins,改造兼容
    // 兼容 methods 中方法 貌似设置空函数可以被重载
    const initTrHeight = () => {}

    // 表单验证dom对象
    const refFormObserver = ref(null)
    // 表单数据项
    const formData = ref({
      configName: '',
      id: 0,
      name: '',
      fieldsObjArray: [{ name: '', title: '', param: '[]', type: 'input' }],
      info: '',
      tableConfig:''
    })
    // 表单数据清空函数
    const resetFormData = () => {
      formData.value = {
        configName: '',
        id: 0,
        name: '',
        fieldsObjArray: [{ name: '', title: '', param: '[]', type: 'input' }],
        info: '',
        tableConfig:''
      }
      refFormObserver.value.reset()
    }
    // 重置内容
    const reset = () => {
      formData.value = JSON.parse(JSON.stringify(props.info))
      refFormObserver.value.reset()
    }

    /* 接口调用区域 */

    /* 组件内部逻辑处理，生命周期问题处理区域 */
    // 处理param popover的回调
    const getParam = (param, index) => {
      // 因为在传参数时候 index + 1
      formData.value.fieldsObjArray[index - 1].param = param
    }

    // 编辑窗口关闭，清空表单并刷新验证，窗口打开时候，获取传递的参数，并且请求接口回去最新的分类列表
    watch(
      () => props.shallShowModal,
      val => {
        if (val) initTrHeight()
        val ? formData.value = JSON.parse(JSON.stringify(props.info)) : resetFormData()
      },
    )

    return {
      formData,
      itemsOptions,
      refFormObserver,
      getParam,
      reset,
      required,
    }
  },
  // Reset Tr Height if data changes
  watch: {
    'formData.fieldsObjArray': {
      handler: function () {
        this.initTrHeight()
      },
      // deep: true
    }
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    addNewItemInItemForm() {
      this.$refs.form.style.overflow = 'hidden'
      this.formData.fieldsObjArray.push({ name: '', title: '', param: '[]', type: 'input' })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
        setTimeout(() => { this.$refs.form.style.overflow = null }, 350)
      })
    },
    removeItem(index) {
      this.formData.fieldsObjArray.splice(index, 1)
      this.trTrimHeight(this.$refs.row[index].offsetHeight)
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => { this.trSetHeight(this.$refs.form ? this.$refs.form.scrollHeight : 0) })
    },
    updateForm() {
      this.refFormObserver.validate().then(success => {
        if (success) {
          this.$emit('up-ok', this.formData)
          this.$emit('update:shall-show-modal', false)
        } else {
          this.initTrHeight()
        }
      })
    },
    resetItem(val, index) {
      // 兼容原来控件类型无需param参数，调整为需要param时候，处理param必须是数组字符串的问题
      this.formData.fieldsObjArray[index].param = '[]'
      // 暂时解决刷新的问题
      setTimeout(() => { this.initTrHeight() }, 200)
    },
  },
}
</script>
<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
  // 加大b-side组件的宽度
  .b-sidebar {
  // Sidebar Width
    &.sidebar-lg {

      @include media-breakpoint-down(xs) {
        width: 20rem;
      }
    }
  }
</style>

<style lang="scss" scoped>
  @import '~@core/scss/base/bootstrap-extended/include';
  @import '~@core/scss/base/components/variables-dark';
  // @import '~@core/scss/vue/bootstrap-vue';
  // 修改card的边距
  .zero-padding-card { padding: 0; }
  // 设置背景色
  .form-item-section-group { background-color: #fcfcfc; }
  // 添加新元素的动画
  .repeater-form-group {
    -webkit-transition: height .35s;
    transition: height .35s;
  }

  .v-select {
  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: unset;
    }
  }
}
  .dark-layout {
    .form-item-section-group {
      background-color: $theme-dark-body-bg;

      .row .border {
        background-color: $theme-dark-card-bg;
      }
    }
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
  .b-sidebar {
  // Sidebar Width
    &.sidebar-customer {
      width: 60rem;

      @include media-breakpoint-down(xs) {
        width: 20rem;
      }
    }
  }
</style>
